import * as ng from 'angular';

const defaults = {
   theme: 'bootstrap',
   position: 'top right',
   defaultValue: '',
   animationSpeed: 50,
   animationEasing: 'swing',
   change: null,
   changeDelay: 0,
   control: 'hue',
   hide: null,
   hideSpeed: 100,
   inline: false,
   letterCase: 'lowercase',
   opacity: false,
   show: null,
   showSpeed: 100
};

ng.module('e360').directive('minicolors', () => {
   return {
      require: 'ngModel',
      scope: {
         minicolors: '<?'
      },
      restrict: 'A',
      link: minicolorsDirectiveLink
   }
})

export function minicolorsDirectiveLink(scope:ng.IScope, element, attrs, ngModelCtrl:ng.INgModelController) {
   let settings = ng.extend({}, defaults, scope['minicolors']);

   settings.change = onValueChange;
   function onValueChange(hex:string) {
      ngModelCtrl.$setViewValue(hex);
   }

   element.minicolors(settings);

   ngModelCtrl.$parsers.push((v) => {
      if (v === '') {
         v = null;
      }

      return v;
   });

   ngModelCtrl.$formatters.push((v) => {
      if (v) {
         element.minicolors('value', v);
         return element.minicolors('value');
      }
   });
}
